import { useEffect } from "react";
import { useSetAtom } from "jotai/react";

import { LoadingScreen } from "@/blocks/LoadingScreen";
import { useSignOutMutation } from "@/data/mutations/authMutations";
import { isManualLogoutAtom } from "@/stores/atoms";

export const LogoutScreen = () => {
  const { mutate: signOut } = useSignOutMutation();
  const setIsManualLogout = useSetAtom(isManualLogoutAtom);

  useEffect(() => {
    setIsManualLogout(true);
    signOut();
  }, [signOut, setIsManualLogout]);

  return (
    <div className="flex flex-1 items-center">
      <LoadingScreen />
    </div>
  );
};
